import React, { useEffect } from "react";
import { getSumCount } from "../../../../api/data";

import modStyl from './index.module.scss'
import { ApiCore } from "../../../../api";
import { set } from "lodash";
import { SpinLoading } from "antd-mobile-v5";

const api = new ApiCore();

// 国耀圣康租户需求
const takeShow = ()=> {
  const env = process.env.REACT_APP_ENV
  const value = localStorage.tenantCode
  if (env === 'test' || env === 'development') {
    return value === 'TENANT-0204'
  }
  return value === 'TENANT-051'
}

// 齐鲁血液演示项目(只有UAT)
const isDemo = ()=> {
  return localStorage.tenantCode === 'TENANT-071'
}

interface PopRecord {
  centerCode: string
  centerGoalNum: number | null
  centerName: string
  subjectNum: number | null
}

interface StatDisplayRecord {
  code: string
  name: string
  type: string
}

interface StatRecord extends StatDisplayRecord {
  value: number | null
}

interface StatValueRecord {
  [key: string]: number | null
}

interface Props {
  editModel?: number
  projectCode?: string
  roleCode?: string
}

const Stat: React.FC<Props> = ({ projectCode, editModel, roleCode }) => {

  const [loading, setLoading] = React.useState(true)

  const [records, setRecords] = React.useState<StatRecord[]>([])

  const [popRecords, setPopRecords] = React.useState<PopRecord[]>([])

  const fetchSumCount = async()=> {
    const {code, message, data} = await getSumCount()
    
    setRecords([
      {
        code: 'allCount',
        name: '患者总数',
        type: '',
        value: data.allCount || 0,
      },
      {
        code: 'groupNum',
        name: '入组患者数',
        type: '',
        value: data.groupNum || 0,
      },
      {
        code: 'questionNum',
        name: '质疑未回复者数',
        type: '',
        value: data.questionNum || 0,
      }
    ])
    setLoading(false)
  }

  const handleClick = async(name: string)=> {
    if(name !== '目标数') {
      return
    }
    const { code, data } = await api.getStats({ projectCode })

    if (!data || data.length === 0) {
      return
    }

    setPopRecords(data || [])
  }

  const fetchStat = async()=> {
    const { code, data } = await api.getSubjectStatistics({ projectCode })

    if (code != '0') {
      return
    }

    const isShow = takeShow()

    const values: StatValueRecord = data.values || {}
    const displays: StatDisplayRecord[] = data.displays || [];

    const re: StatRecord[] = []

    for (let item of displays) {
      let value = values[item.code]
      if (typeof value === 'undefined') {
        continue
      }

      if (isShow && item.name === '未签名') {
        item.name = '目标数'
        value = data.goalNum
      }
      re.push({
        ...item,
        value,
      })
    }

    setRecords(re)
    setLoading(false)
  }

  useEffect(()=> {
    if (projectCode) {
      setLoading(true)
      if (editModel === 1 || isDemo()) {
        fetchSumCount()
      } else {
        fetchStat()
      }
    }
  }, [editModel, projectCode])

  if (loading) {
    return (
      <div className={modStyl.wrapper}>
        <div className={modStyl.loading}>
          <SpinLoading />
        </div>
      </div>
    )
  }
  
  return (
    (
      <div className={modStyl.wrapper}>
        <div className={modStyl.columns} style={{ display: roleCode == 'EDC_PI' ? 'none' : 'inlineBlock' }}>
          <ul>
            {
              records.map(({code, name, value}) => (
                <li onClick={()=> handleClick(name)} key={code}>
                  <dl>
                    <dt className={modStyl.staticsName}>{name}</dt>
                    <dd className={modStyl.staticsNum}>{ value || 0}</dd>
                  </dl>
                </li>
              ))
            }
          </ul>
        </div>
        {
          popRecords.length > 0 && (
            <div className={modStyl.targets}>
              {
                popRecords.map(({  centerName, subjectNum, centerGoalNum }) => (
                  <div className={modStyl.targetDiv}>
                    <div><span className={modStyl.targetNum }>{subjectNum || 0}</span>/{centerGoalNum || '--'}</div>
                    <div className={modStyl.targetFont}>{centerName}</div>
                  </div>
                ))
              }
            </div>
          )
        }
      </div>
    )
  );
}

export default Stat;
